import { render, staticRenderFns } from "./MMP_GTP_Report.vue?vue&type=template&id=87073ee2&"
import script from "./MMP_GTP_Report.vue?vue&type=script&lang=js&"
export * from "./MMP_GTP_Report.vue?vue&type=script&lang=js&"
import style0 from "./MMP_GTP_Report.vue?vue&type=style&index=0&id=87073ee2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports